/** Ekstrak ID video YouTube dari berbagai format URL. */
export function extractYouTubeId(url) {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();

  let match = trimmed.match(/youtube\.com\/embed\/([^?&/]+)/i);
  if (match) return match[1];

  match = trimmed.match(/[?&]v=([^?&/]+)/i);
  if (match) return match[1];

  match = trimmed.match(/youtu\.be\/([^?&/]+)/i);
  if (match) return match[1];

  match = trimmed.match(/youtube\.com\/shorts\/([^?&/]+)/i);
  if (match) return match[1];

  return null;
}

export function isValidYouTubeUrl(url) {
  return !!extractYouTubeId(url);
}

export function toYouTubeEmbedUrl(url) {
  const id = extractYouTubeId(url);
  return id ? `https://www.youtube.com/embed/${id}` : '';
}
